export const GET_BD_REDEEM = "GET_BD_REDEEM";

export const ACCEPT_BD_REDEEM = "ACCEPT_BD_REDEEM";
export const DECLINE_BD_REDEEM = "DECLINE_BD_REDEEM";

export const GET_MY_BD_REDEEM = "GET_MY_BD_REDEEM";
export const OPEN_NEW_BD_REDEEM_DIALOG = "OPEN_NEW_BD_REDEEM_DIALOG";
export const CLOSE_NEW_BD_REDEEM_DIALOG = "CLOSE_NEW_BD_REDEEM_DIALOG";

export const NEW_BD_REDEEM_CREATE = "NEW_BD_REDEEM_CREATE";
export const CLEAR_BD_REDEEM = "CLEAR_BD_REDEEM";
